import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useNotify from "hooks/useNotify";
import { actions } from "store/actions";
import { actions as projectActions } from "store/actions";
import { scrollIntoView } from "utils/helper";

function UseBankDetailsInformation() {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.userDetails || {});
  const [isLoading, setIsLoading] = useState(false);
  const { notifyError, notifySuccess } = useNotify();

  const onEditBankDetails = async (values) => {
    try {
      setIsLoading(true);
      const bankDetails = {
        companyName: values?.companyName || undefined,
        accountName: values?.accountName || undefined,
        bankName: values?.bankName || undefined,
        accountNumber: values?.accountNumber || undefined,
        accountCurrency: values?.accountCurrency || undefined,
        swiftCode: values?.swiftCode || undefined,
        iban: values?.iban || undefined,
        bankAddress: values?.bankAddress || undefined,
        routingCode: values?.routingCode || undefined,
        sortCode: values?.sortCode || undefined,
      };
      const payload = {
        bankDetails,
      };

      dispatch(
        projectActions.updateBankDetailsCommon(payload, (isSuccess, err) => {
          setIsLoading(false);

          if (isSuccess) {
            const updatedBankDetails = {
              ...userDetails,
              bankDetails: {
                ...userDetails?.bankDetails,
                ...bankDetails,
              },
            };
            dispatch(actions.setUserDetails(updatedBankDetails));
            notifySuccess("Has been updated successfully");
            scrollIntoView("bankDetailsSection");
          } else {
            notifyError(
              err?.data?.error ?? err?.message ?? "Something went wrong!"
            );
          }
        })
      );
    } catch (err) {
      console.error(err);
      notifyError(err?.data?.error ?? err?.message ?? "Something went wrong!");
    }
  };

  useEffect(() => () => {}, []);

  return { onEditBankDetails, isBankDetailsLoading: isLoading };
}

export default UseBankDetailsInformation;
